import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=6fe244b9"
import script from "./warehouse.vue?vue&type=script&lang=js"
export * from "./warehouse.vue?vue&type=script&lang=js"
import style0 from "./warehouse.vue?vue&type=style&index=0&id=6fe244b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports